/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import GitCommit from '../../../_git_commit';

/**
 * This is the commit message of the last commit before building or running this project
 * @see package.json git-info for how to generate this commit
 */

const GitInfo = () => {
  const navigate = useNavigate();
  const logClick = useCallback(
    (event: any) => {
      if (event.shiftKey) {
        // Go to /admin/logs
        navigate('/admin/logs');
      }
    },
    [navigate]
  );

  return (
    <div onClick={logClick}>
      <span title={GitCommit.gitinfo}>Version: {GitCommit.logMessage}</span>
      &nbsp; <span>{GitCommit.datetime}</span>
    </div>
  );
};

export default GitInfo;
